import React from "react";
import { components } from "react-select";
export const PlaceSearchInput = (props: any) => (
  <components.Input {...props} isHidden={false}>
    {props.children}
  </components.Input>
);
